import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CapitalSocialSnapshot,
  SocioSnapshot,
} from '../../models/constitution-snapshot.model';
import {
  buildSociosTituloRows,
  formatEuro,
  totalSociosShares,
} from '../../../constitution-form/utils/socios-display.util';
import { formatShareAmountEs } from '../../../constitution-form/utils/format-share-amount';

@Component({
  selector: 'app-constitution-socios-readonly-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './constitution-socios-readonly-table.component.html',
  styleUrl: '../../../constitution-form/constitution-form.component.scss',
})
export class ConstitutionSociosReadonlyTableComponent {
  socios = input.required<SocioSnapshot[]>();
  capital = input.required<CapitalSocialSnapshot>();
  /** When the list only has the shares touched by an operation (e.g. 'Acciones amortizadas'). */
  partialLabel = input<string | null>(null);

  socioSelected = output<SocioSnapshot>();

  readonly hoveredSocioIndex = signal<number | null>(null);

  readonly rows = computed(() => buildSociosTituloRows(this.socios(), this.capital()));
  readonly totalSocios = computed(() => totalSociosShares(this.socios()));
  readonly totalEmpresa = computed(() => this.capital().totalAcciones);

  readonly formatShareAmount = formatShareAmountEs;
  readonly formatEuro = formatEuro;

  formatAdjusted(value: number): string {
    return formatShareAmountEs(value, 4);
  }

  onRowClick(socio: SocioSnapshot): void {
    this.socioSelected.emit(socio);
  }

  onRowKeydown(event: KeyboardEvent, socio: SocioSnapshot): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.socioSelected.emit(socio);
    }
  }

  onSocioRowEnter(socioIndex: number): void {
    this.hoveredSocioIndex.set(socioIndex);
  }

  onSociosTableBodyLeave(): void {
    this.hoveredSocioIndex.set(null);
  }
}
